var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8281 9.01367C18.8281 9.21258 18.7491 9.40335 18.6085 9.544C18.4678 9.68465 18.277 9.76367 18.0781 9.76367H10.5781V17.2637C10.5781 17.4626 10.4991 17.6534 10.3585 17.794C10.2178 17.9347 10.027 18.0137 9.82812 18.0137C9.62921 18.0137 9.43845 17.9347 9.2978 17.794C9.15714 17.6534 9.07812 17.4626 9.07812 17.2637V9.76367H1.57812C1.37921 9.76367 1.18845 9.68465 1.0478 9.544C0.907143 9.40335 0.828125 9.21258 0.828125 9.01367C0.828125 8.81476 0.907143 8.62399 1.0478 8.48334C1.18845 8.34269 1.37921 8.26367 1.57812 8.26367H9.07812V0.763672C9.07812 0.56476 9.15714 0.373994 9.2978 0.233342C9.43845 0.0926897 9.62921 0.0136719 9.82812 0.0136719C10.027 0.0136719 10.2178 0.0926897 10.3585 0.233342C10.4991 0.373994 10.5781 0.56476 10.5781 0.763672V8.26367H18.0781C18.277 8.26367 18.4678 8.34269 18.6085 8.48334C18.7491 8.62399 18.8281 8.81476 18.8281 9.01367Z",
    fill: "#F7F9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5ec23ee895b5194f4d418bd644d048eb.svg";
export { ForwardRef as ReactComponent };